<img [src]="file | preview">
<span>{{file?.name}}</span>